module.exports = __webpack_public_path__ + "assets/ba136dc15e1b7303c17f29cfe5476518.mp3";